import type { FilteringService } from '.';

import { Environment } from '../../../environments/environment';
import { Sort } from './sort';

export function Params(this: FilteringService): Record<string, unknown> {
  return {
    areas: this.areas().length > 0 ? this.areas().join(',') : undefined,
    baths: this.baths().length > 0 ? this.baths().join(',') : undefined,
    beds: this.beds().length > 0 ? this.beds().join(',') : undefined,
    community: Environment.community,
    features: this.homesites().length > 0 ? this.homesites().join(',') : undefined,
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Required for the API.
    'garage-predefined': this.garages().length > 0 ? this.garages().join(',') : undefined,
    geoWithin:
      this.geoWithin().length > 0 ? this.geoWithin().map((coord) => coord.join(',')) : undefined,
    limit: this.limit(),
    models: this.models().length > 0 ? this.models().join(',') : undefined,
    onlyOpenHouses: this.openHomes() ? true : undefined,
    pending: this.includePendingSales() ? true : undefined,
    pool: this.pool() ? true : undefined,
    priceHigh: Number(this.priceHigh()) > 0 ? Number(this.priceHigh()) : undefined,
    priceLow: Number(this.priceLow()) > 0 ? Number(this.priceLow()) : undefined,
    reps: this.reps() ? this.reps() : undefined,
    saleTypes: this.saleTypes(),
    search: this.search() ? this.search() : undefined,
    series: this.series().length > 0 ? this.series().join(',') : undefined,
    sort: Sort.call(this),
    squareFeetLow: Number(this.minSqft()) ? Number(this.minSqft()) : undefined,
    uliKey: this.uliKey().length ? this.uliKey() : undefined,
    unit: this.unit().length > 0 ? this.unit().join(',') : undefined,
  };
}
